// Copyright (c) 2024-2026 HiveHQ Technologies Private Limited. All Rights Reserved. Proprietary and Confidential.
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import App from './App.tsx'
import './index.css'
import "./styles/global.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, 
  // Session Replay
  replaysSessionSampleRate: 0.0, // Set to 0 to save your monthly quota of 50 replays
  replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions where an error occurs
});

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<div style={{ padding: "20px" }}>An unexpected error occurred. Our team has been notified.</div>}>
    <App />
  </Sentry.ErrorBoundary>
);
